import { render, staticRenderFns } from "./allCompanyList.vue?vue&type=template&id=d967106e&scoped=true&"
import script from "./allCompanyList.vue?vue&type=script&lang=js&"
export * from "./allCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./allCompanyList.vue?vue&type=style&index=0&id=d967106e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d967106e",
  null
  
)

export default component.exports